/**
 * Shared sale countdown — drives every "Free shipping ends in HH:MM:SS" clock.
 *
 * Cleanup tag: JULY4-SALE-2026
 *
 * Source of truth is a single end timestamp (window.__TEC_SALE.endTs, an ISO 8601
 * string with offset, set from the theme setting). One 1Hz interval updates every
 * element carrying [data-sale-countdown] — including clocks the cart script injects
 * later, since we re-query each tick (cheap at 1Hz). Hours are NOT clamped to 24:
 * 250 hours renders as e.g. 142:08:23.
 *
 * When the clock passes zero it stops, writes 00:00:00, hides anything marked
 * [data-sale-hide-on-end] (and the closest such ancestor), and flips
 * window.SaleCountdown.ended so the banner/cart can drop the "ends in" framing.
 * Fully ending the sale is a separate manual step (untick the theme toggle).
 */
(function () {
  'use strict';

  var CFG = (typeof window !== 'undefined' && window.__TEC_SALE) || {};
  var END_MS = CFG.endTs ? Date.parse(CFG.endTs) : NaN;
  var hasEnd = !isNaN(END_MS);

  function remaining() {
    return hasEnd ? Math.max(0, END_MS - Date.now()) : 0;
  }

  // ms → "H:MM:SS" / "HH:MM:SS" / "HHH:MM:SS" (total hours, never rolled into days).
  function format(ms) {
    var total = Math.max(0, Math.floor(ms / 1000));
    var h = Math.floor(total / 3600);
    var m = Math.floor((total % 3600) / 60);
    var s = total % 60;
    var hh = h < 10 ? '0' + h : '' + h;       // pad to 2, grow naturally past 99
    var mm = m < 10 ? '0' + m : '' + m;
    var ss = s < 10 ? '0' + s : '' + s;
    return hh + ':' + mm + ':' + ss;
  }

  var ended = false;

  function hideEndedTargets() {
    var nodes = document.querySelectorAll('[data-sale-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      var target = el.closest('[data-sale-hide-on-end]') || el;
      target.setAttribute('hidden', '');
    }
  }

  function paint() {
    var ms = remaining();
    var text = format(ms);
    var nodes = document.querySelectorAll('[data-sale-countdown]');
    for (var i = 0; i < nodes.length; i++) {
      if (nodes[i].textContent !== text) nodes[i].textContent = text;
    }
    if (hasEnd && ms <= 0 && !ended) {
      ended = true;
      window.SaleCountdown.ended = true;
      hideEndedTargets();
      try {
        document.dispatchEvent(new CustomEvent('tec:sale-countdown-ended'));
      } catch (e) {}
    }
  }

  var intervalId = null;
  function start() {
    if (intervalId || !hasEnd) { paint(); return; }
    paint();
    intervalId = window.setInterval(function () {
      paint();
      if (ended) { window.clearInterval(intervalId); intervalId = null; }
    }, 1000);
  }

  // ─── Public API (the cart ticker reuses format()/remaining()) ────────────────
  window.SaleCountdown = {
    format: format,
    remaining: remaining,
    endMs: function () { return END_MS; },
    hasEnd: hasEnd,
    ended: false,
    refresh: paint
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
